import { render, staticRenderFns } from "./pick-order.vue?vue&type=template&id=5236f5c6&scoped=true"
import script from "./pick-order.vue?vue&type=script&lang=ts"
export * from "./pick-order.vue?vue&type=script&lang=ts"
import style0 from "./pick-order.vue?vue&type=style&index=0&id=5236f5c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5236f5c6",
  null
  
)

export default component.exports